if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form[action$="/cart/add"]');
			this.productIdInput = this.form?.querySelector('[name=id]');
			this.addButtons = this.querySelectorAll('button[name="add"]');

			if (this.form && this.productIdInput) {
				this.productIdInput.disabled = false;
				this.form.addEventListener('submit', this.formSubmit.bind(this));
			}
		}

		async formSubmit(evt) {

			evt.preventDefault();

			if (!this.productIdInput?.value) {
				this.variantError();
				return;
			}

			document.querySelector('.product-error')?.remove();
			this.removeErrorsBlock();
			this.toggleLoadingState(true);

			try {
				const config = {
					...fetchConfig('javascript'),
					body: new FormData(this.form)
				};
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];


				const response = await fetch(`${routes.cart_add_url}`, config);
				const data = await response.json();

				if (data.status) {
					this.errorMessage(data);
					return;
				}

				this.success();
			} catch (error) {
				console.error('Add to cart error:', error);
				this.toggleLoadingState(false);
			}
		}

		toggleLoadingState(isLoading) {
			this.addButtons?.forEach(button => {
				button.classList.toggle('loading', isLoading);
			});
		}

		errorMessage(resp) {
			console.log(resp)
			if (resp.status === 422) {
				if(this.closest('.global-error-container')){
					let errorBlock = document.createElement('p');
					errorBlock.classList.add('product-error');
					errorBlock.innerHTML = resp.message
					if(this.closest('.global-error-container').querySelector(`.product-error`)){
						this.closest('.global-error-container').querySelector(`.product-error`).innerHTML = resp.message
					}else{
						this.closest('.global-error-container').prepend(errorBlock);
					}
				}

				this.success();

			}
			this.toggleLoadingState(false);
		}



		success() {
			console.log("Product added to cart")
			this.toggleLoadingState(false);

			updateCartCount();
			updateCartPopup();

			if(document.querySelector('#choose-option-popup')){
				document.querySelector('#choose-option-popup').classList.remove('open');
				document.querySelector('#choose-option-popup').classList.remove('animation');
				unlockScrollbar()
			}


			if (!document.querySelector('.js-cart-page')) {
				this.openCartPopup();
			}
			if(document.querySelector('.js-cart-page cart-item')){
				document.querySelector('.js-cart-page ').classList.add('loading')
				document.querySelector('.js-cart-page cart-item').updateCartContent();
			}else if(document.querySelector('.js-cart-page')){
				window.location.reload();
			}
		}

		variantError() {
			console.error('Product variant not selected');
		}

		removeErrorsBlock() {
			// Implementation for removing error blocks
		}
		openCartPopup(){
			const cartPopup = document.querySelector('#cart-popup')
			cartPopup.classList.add('open');
			setTimeout(function () {
				cartPopup.classList.add('animation')
			}, 200);
			lockScrollbar();
		}
	});
}

if (!customElements.get('product-button')) {
	customElements.define('product-button', class ProductButton extends HTMLElement {
		constructor() {
			super();
			this.init();
		}

		init() {
			this.button = this.querySelector('button');
			if (!this.button) return;

			this.variantId = this.button.dataset.variantId;
			this.quantity = this.button.dataset.quantity || 1;
			if (!this.variantId) {
				console.error('Missing variant ID for product button');
				return;
			}

			this.button.addEventListener('click', this.handleClick.bind(this));
		}

		async handleClick(event) {
			event.preventDefault();

			const formData = {
				items: [{
					id: this.variantId,
					quantity: this.quantity
				}]
			};

			try {
				const response = await this.addToCart(formData);

				if (response.status) {
					this.handleError(response);
					return;
				}

				this.handleSuccess();
			} catch (error) {
				console.error('Add to cart error:', error);
				this.handleError({ description: 'Failed to add product to cart' });
			}
		}

		async addToCart(formData) {
			const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify(formData)
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			return response.json();
		}

		handleError(response) {
			console.error('Add to cart error:', response.description);
			// Here you can implement custom error UI feedback
		}

		handleSuccess() {

			this.updateCart();
		}

		updateCart() {
			updateCartPopup();
			updateCartCount();
			if(this.closest('cart-item')){
				this.closest('cart-item').remove();
			}
			if(document.querySelector('cart-item')){
				document.querySelector('cart-item').updateCartContent();
			}
		}
	});
}